import React from "react";
import Row from "react-bootstrap/Row";
import Col from "react-bootstrap/Col";
import Spinner from "react-bootstrap/Spinner";
import Button from "react-bootstrap/Button";

const LoadMore = ({ loading, items, hasMore, pagination }) => (
  <Row>
    <Col xs={12} className="col-load-more col-text-center">
      {loading && items && (
        <div>
          <Spinner animation="border" size="sm" /> Loading {items.length > 0 ? "more" : ""}...
        </div>
      )}
      {!loading && hasMore && (
        <Button onClick={(e) => pagination(e)} variant="outline-light" type="submit">
          Load More
        </Button>
      )}
    </Col>
  </Row>
);

export default LoadMore;
